import React, { useEffect } from 'react';

// Augment the Window interface to include adsbygoogle
declare global {
  interface Window {
    adsbygoogle?: { [key: string]: unknown }[];
  }
}
    
    const AdComponent = () => {
      useEffect(() => {
        const adContainer = document.getElementById('ad-container');
        const ins = document.createElement('ins');
        ins.className = 'adsbygoogle';
        if (adContainer) {
          adContainer.appendChild(ins);
          // Check if adsbygoogle is already initialized
          try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
          } catch (e) {
            console.error("Error pushing adsbygoogle:", e);
          }
        }
      }, []);
    
      return <div id="ad-container" />;
    };
    
    export default AdComponent;